let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("es24U")).then(() => parcelRequire('8VLDD'));